import React from 'react';
import { connect } from 'react-redux';
import styles from './Button.scss';
import { theme, Theme, ThemeButton } from '../../reducers';

interface ButtonProps {
  onClick(): any;
  dataHook?: string;
  disabled?: boolean;
  lightButton?: boolean;
  defaultColor?: ThemeButton;
  themeData?: Theme;
}

export class Button extends React.Component<ButtonProps> {
  static defaultProps = {
    lightButton: false,
  };

  getTheme = (): ThemeButton => {
    const { themeData, lightButton, disabled, defaultColor } = this.props;

    if (!themeData && defaultColor) {
      return defaultColor;
    }
    if (!themeData) {
      throw new Error(`<Button /> must get themeData or defaultColor`);
    }
    const { light, disable, enable } = themeData.button;
    if (lightButton) {
      return light;
    }
    if (disabled) {
      return disable;
    }
    return enable;
  };

  getRadius = (): number | undefined => {
    return this.props.themeData ? this.props.themeData.button.borderRadius : 20;
  };

  render() {
    const { onClick, children, dataHook } = this.props;
    const disabled =
      this.props.disabled === undefined ? false : this.props.disabled;

    const { color, backgroundColor, borderColor } = this.getTheme();
    const borderRadius = this.getRadius();

    const borderWidth = borderColor ? '1px' : undefined;
    const borderStyle = borderColor ? 'solid' : undefined;

    return (
      <button
        className={styles.button}
        style={{
          backgroundColor,
          color,
          borderWidth,
          borderColor,
          borderStyle,
          borderRadius,
        }}
        data-hook={dataHook || 'widget-button'}
        onClick={onClick}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }
}

function mapStateToProps(state) {
  return {
    themeData: theme(state),
  };
}

export const ThemedButton = connect(mapStateToProps)(Button);
export default ThemedButton;
